import React, { useContext, useEffect, useState } from "react";
import { PatioContext } from "context/patio-calculator";
import RadioProductsCards from "../../_components/radio-products-cards";
import DropdownProductsSelect from "../../_components/dropdown-products-select";

const CustomizationContainer = ({ data, index }) => {
    const { configuration, customAttributes, updateConfiguration, setCustomAttributes } = useContext(PatioContext);

    let value = customAttributes[`c_${data.title}`];
    let variantId = data.variants.find((variant) => variant.title?.replace(/::.*$/, "") === value)?.id;

    const [currentKey, setCurrentKey] = useState(variantId || data.default_variant_id);

    const updateCustomization = (variantId, title) => {
        const numericVariantId = Number(variantId);
        const numericCurrentKey = Number(currentKey);
        
        const clearedVariants = configuration.customization_variant_ids
            .map(id => Number(id))
            .filter((vid) => vid !== numericCurrentKey);
            
        updateConfiguration({ 
            customization_variant_ids: [...clearedVariants, numericVariantId] 
        });

        setCustomAttributes((prevAttributes) => ({
            ...prevAttributes,
            [`c_${data.title}`]: title || "n/a",
        }));

        setCurrentKey(numericVariantId);
    };

    const getVariants = () => data.variants.map((variant) => ({
        ...variant,
        title: variant.title.replace(/::.*$/, ""),
    }));

    useEffect(() => {
        if (data.default_variant_id && !variantId) {
            const defaultItem = data.variants.find((variant) => variant.id === data.default_variant_id);
            const replaceDefault = defaultItem?.title.replace(/::.*$/, "");
            updateCustomization(data.default_variant_id, replaceDefault);
        }
    }, [data.default_variant_id, data.variants, data.title]);

    const handleChange = (itemId, item) => {
        updateCustomization(itemId, item?.title);
    };

    return (
        <div className="configurator-section">
            <div className="configurator-section__header">
                <h3 className="configurator-section__header-title">{`${index}. ${data?.title}`}</h3>
            </div>
            <div className="configurator-section__inner">
                {data.type === "Grid" && (
                    <RadioProductsCards
                        items={getVariants()}
                        onChange={handleChange}
                        value={currentKey}
                    />
                )}
                {data.type === "Dropdown" && (
                    <DropdownProductsSelect
                        items={getVariants()}
                        onChange={handleChange}
                        value={currentKey}
                    />
                )}
            </div>
        </div>
    );
};

const Customization = ({ customizations = [], startIndex }) => (
    <>
        {customizations.map((customization, idx) => {
            const calculatedIndex = startIndex + idx;
            return (
                <CustomizationContainer
                    key={customization.id}
                    data={customization}
                    index={calculatedIndex}
                />
            );
        })}
    </>
);

export default Customization;
